import styled from 'styled-components';

export const CouponCode = styled.div`
  margin: 0 auto;
  text-align: center;
  padding: 1em;
  width: 50%;
`;
